module.exports = __webpack_public_path__ + "static/media/g.a650deed.png";